export default __webpack_public_path__ + "static/media/deno.04aa2c4d.svg";